import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { loadAction } from '../../util/decorators';
import { getDefaultMetaData } from '../../util/metaDataBuilder';
import loadBroadcastAreaData from '../../action/loadBroadcastAreaData';
import Navbar from '../Navigation/Navbar.jsx';
import Breakpoint from '../Breakpoint.jsx';
import Modal from './Modal';
import CookieNotification from './CookieNotification.jsx';
import UnsupportedBrowserNotification from './UnsupportedBrowserNotification.jsx';
import config from '../../config';
import ravenConfig from '../../config/ravenConfig';
import cookieConfig from '../../config/cookie';

const { NODE_ENV, REVISION, BUILD, CONFIG_PROFILE } = config;

const mapStateToProps = state => ({
  country: state.country,
  language: state.language,
  cookie: cookieConfig[state.country],
});

@loadAction(loadBroadcastAreaData)
@connect(mapStateToProps)
export default class App extends React.PureComponent {
  static propTypes = {
    children: React.PropTypes.element.isRequired,
    modal: React.PropTypes.string,
    location: React.PropTypes.shape({
      pathname: React.PropTypes.string,
    }),
    socialMediaLinks: React.PropTypes.shape({
      facebook: React.PropTypes.array,
      twitter: React.PropTypes.array,
    }),
    meta: React.PropTypes.object,
    country: React.PropTypes.string,
    cookie: React.PropTypes.shape({
      enabled: React.PropTypes.bool,
      url: React.PropTypes.string,
    }),
  };

  componentDidMount() {
    if (NODE_ENV === 'production') {
      /* Origin: https://docs.getsentry.com/hosted/clients/javascript/tips/ */
      const ravenOptions = {
        release: REVISION,
        tags: {
          environment: CONFIG_PROFILE,
          build: BUILD,
        },
        ignoreErrors: ravenConfig.ignoreErrors,
        ignoreUrls: ravenConfig.ignoreUrls,
      };
      window.Raven.config(ravenConfig.url, ravenOptions).install();
    }
  }

  render() {
    const { location, children, country, cookie } = this.props;

    // IMPORTANT: Do not remove this id, since it's used by takeover ads to bind click events
    // TODO: Find another solution to the takeover click issue (https://jira.mtg.com/browse/VIP-25358)
    const takeoverClickAreaId = 'takeover-click-area';

    return (
      <div id={takeoverClickAreaId}>

        <Helmet {...getDefaultMetaData(country)} />

        <header id="header">
          <Navbar path={location.pathname} />
        </header>

        { location.pathname === '/' && <CookieNotification enabled={cookie.enabled} url={cookie.url} /> }

         <Modal />

        <div className="container-fluid" id="main-content">
          {children}
        </div>

        <Breakpoint />

        <UnsupportedBrowserNotification />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/App.jsx